
const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery',
      description: 'We analyze your requirements and identify the best technology solutions for your business goals.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Strategy',
      description: 'Develop a comprehensive roadmap with clear timelines, milestones, and deliverables.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '03',
      title: 'Implementation',
      description: 'Execute solutions with precision, ensuring quality and compliance at every step.',
      icon: 'ri-rocket-line'
    },
    {
      number: '04',
      title: 'Success',
      description: 'Complete delivery with full documentation, training, and ongoing support.',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-slate-900/30 to-slate-800/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-32 right-20 w-80 h-80 bg-cyan-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 left-20 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-6">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-blue-600/20 text-blue-300 rounded-full text-sm font-medium border border-blue-400/30">
              Our Methodology
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">
            Proven <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Process</strong>
          </h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto font-light leading-relaxed">
            A systematic approach that ensures successful project delivery and long-term partnership success
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative group"
            >
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-blue-400/30 to-cyan-400/30 -translate-x-1/2 z-0" />
              )}
              
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                <div className="relative bg-white/8 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:border-blue-400/40 transition-all duration-500 hover:shadow-2xl hover:shadow-blue-500/10 group-hover:bg-white/12 z-10 h-full">
                  <div className="text-6xl font-light text-blue-400/20 mb-4">
                    {step.number}
                  </div>
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-600/30 to-cyan-600/30 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                    <i className={`${step.icon} text-2xl text-blue-300`}></i>
                  </div>
                  <h3 className="text-2xl font-semibold text-white mb-4 group-hover:text-blue-100 transition-colors duration-300">
                    {step.title}
                  </h3>
                  <p className="text-white/80 leading-relaxed font-light">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
